/* eslint-disable no-unused-vars */
export enum TransactionType {
  Scommesse = 'SCOMMESSE',
  Voucher = 'VOUCHER',
  Lotterie = 'LOTTERIE',
  Bingo = 'BINGO',
  Withdraw = 'PRELIEVO',
  TotoCalcio = 'TOTOCALCIO',
  WithdrawBonifico = 'PrelievoBonifico',
  WithdrawCard = 'Prelievo con Carta',
}
/* eslint-enable no-unused-vars */
